module.exports = __webpack_public_path__ + "img/20220617115862306230.05f134ca.jpg";